// shared.module.ts

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LocalInvoiceComponent } from '../Components/enterprise/local-invoice/local-invoice.component';
import { IPListingComponent } from '../Components/enterprise/iplisting/iplisting.component';
import { AboutTrinkaComponent } from '../Components/enterprise/about-trinka/about-trinka.component';
import { IntergradeSoftwareComponent } from '../Components/enterprise/intergrade-software/intergrade-software.component';
import { PersonalPricingComponent } from '../Components/enterprise/personal-pricing/personal-pricing.component';
import { LearnMoreSectionComponent } from '../Components/enterprise/custom-aimodels/learn-more-section/learn-more-section.component';

@NgModule({
  declarations: [
    LocalInvoiceComponent,
    IPListingComponent,
    AboutTrinkaComponent,
    IntergradeSoftwareComponent,
    PersonalPricingComponent,
    LearnMoreSectionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule
  ],
  exports: [
    LocalInvoiceComponent,
    IPListingComponent,
    AboutTrinkaComponent,
    IntergradeSoftwareComponent,
    PersonalPricingComponent,
    LearnMoreSectionComponent
  ]
})

export class EnterpriseSharedModule { }
